import { available, isU64, PRICE_SCALE_D9, unavailable } from './integer.js';
import type { PoolMathResult } from './types.js';

export interface OutcomeTokenSpotValueInput {
  /** Outcome-token quantity in D6 base units. */
  outcomeAmountD6: bigint;
  /** Marginal pool price in D9 USDC per outcome token. */
  spotPriceD9: bigint;
}

/**
 * Estimates an outcome-token amount's USDC value at a marginal spot price.
 *
 * This is intentionally linear mark-to-spot math for indicative displays and
 * fee notionals. It is not a sell quote, liquidation value, or P&L input; those
 * must use the active pool's full exact-out sell quote so price impact and fees
 * are included. Division rounds down, matching integer on-chain notional math.
 */
export function estimateOutcomeTokenSpotValueD6(
  input: OutcomeTokenSpotValueInput,
): PoolMathResult<bigint> {
  if (!isU64(input.outcomeAmountD6) || !isU64(input.spotPriceD9)) {
    return unavailable('invalid_amount');
  }

  const valueD6 = (input.outcomeAmountD6 * input.spotPriceD9) / PRICE_SCALE_D9;
  return isU64(valueD6) ? available(valueD6) : unavailable('invalid_amount');
}
